module.exports = __webpack_public_path__ + "img/top_bg.856242e8.png";